<template>
  <div class="delete-archive-dialog-box">
    <el-dialog
      :title="isBackup ? $t('wrh-dashboard.delete-dialog-box.title.backup') :
      $t('wrh-dashboard.delete-dialog-box.title.archive')"
      @close="onClose"
      visible
    >
      <div class="el-text el-text--body-24 mx-24 my-16">
        {{ isBackup ? $t('wrh-dashboard.delete-dialog-box.message.backup') :
        $t('wrh-dashboard.delete-dialog-box.message.archive') }}
      </div>

      <template slot="footer">
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary"
        >
          {{ $t('wrh-dashboard.form.button.cancel') }}
        </el-button>
        <el-button
          native-type="button"
          @click="onDelete"
          type="danger"
          :loading="isInProgress"
          :disabled="isInProgress"
        >
          {{ $t('wrh-dashboard.form.button.delete') }}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  DELETE_ARCHIVE
} from '../store/action-types';

import {
  PENDING_STATUS,
  COMPLETED_STATUS
} from '../store/action-status';

const { mapGetters, mapActions } = createNamespacedHelpers('wrh-dashboard');

export default {
  name: 'DeleteArchiveDialogBox',
  props: {
    archiveId: {
      type: String,
      default: '',
      required: true
    },
    boxGroup: {
      type: String,
      default: 'ARCHIVES',
      required: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getArchiveDeletionStatus'
    ]),
    isBackup() {
      return this.boxGroup === 'BACKUPS';
    },
    isInProgress() {
      return this.getArchiveDeletionStatus === PENDING_STATUS;
    }
  },
  watch: {
    getArchiveDeletionStatus(status) {
      if (status === COMPLETED_STATUS) {
        this.onClose();
      }
    }
  },
  methods: {
    ...mapActions({
      deleteArchive: DELETE_ARCHIVE
    }),
    onDelete() {
      this.deleteArchive(this.archiveId);
    },
    onClose() {
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
